export interface WorkApproval {
  id: string;
  type: 'listing' | 'purchase_plan';
  title: string;
  applicant: string;
  department: string;
  status: 'pending' | 'approving' | 'approved' | 'rejected';
  createdAt: string;
  updatedAt?: string;
  description: string;
  relatedInfo?: string;
  approvalSteps: {
    level: number;
    approverName: string;
    role: string;
    status: 'pending' | 'approved' | 'rejected';
    approvedAt?: string;
    comment?: string;
  }[];
}

export const workApprovals: WorkApproval[] = [
  {
    id: 'wa1',
    type: 'listing',
    title: '一次性无菌注射器（2ml规格）上架申请',
    applicant: '杨药师',
    department: '药剂科',
    status: 'pending',
    createdAt: '2026-07-25T09:00:00Z',
    description: '申请新增一次性无菌注射器2ml规格上架，用于儿科和老年科日常注射使用。该产品已通过质量检测，符合YY/T0573-2018标准。',
    relatedInfo: '产品批号：ZC20260701-001；供应商：广西医疗器械供应有限公司',
    approvalSteps: [
      { level: 1, approverName: '马主任', role: '科室主管', status: 'pending' },
      { level: 2, approverName: '王管理员', role: '平台管理员', status: 'pending' },
      { level: 3, approverName: '刘科长', role: '设备科审批', status: 'pending' },
    ],
  },
  {
    id: 'wa2',
    type: 'listing',
    title: '医用防护服（连体型）上架申请',
    applicant: '张采购',
    department: '医务科',
    status: 'approving',
    createdAt: '2026-07-23T14:00:00Z',
    updatedAt: '2026-07-24T10:30:00Z',
    description: '申请新增医用一次性防护服（连体型），适用于传染病防控和隔离区使用，符合GB19082-2009标准。',
    relatedInfo: '供应商：广西医疗器械供应有限公司；预计月用量：200套',
    approvalSteps: [
      { level: 1, approverName: '王主任', role: '科室主管', status: 'approved', approvedAt: '2026-07-24T09:00:00Z', comment: '同意上架，疫情防控需要' },
      { level: 2, approverName: '王管理员', role: '平台管理员', status: 'pending' },
      { level: 3, approverName: '刘科长', role: '设备科审批', status: 'pending' },
    ],
  },
  {
    id: 'wa3',
    type: 'purchase_plan',
    title: '护理部2026年Q3季度采购计划',
    applicant: '陈护士长',
    department: '护理部',
    status: 'approving',
    createdAt: '2026-07-22T10:00:00Z',
    updatedAt: '2026-07-24T15:00:00Z',
    description: '护理部第三季度常规耗材采购计划，总预算50000元。包括：口罩、手套、纱布、消毒液等日常护理耗材。',
    relatedInfo: '计划编号：JH2026-Q3-002；预算金额：¥50,000.00；预算科目：护理耗材',
    approvalSteps: [
      { level: 1, approverName: '陈护士长', role: '部门主管', status: 'approved', approvedAt: '2026-07-23T08:30:00Z', comment: '计划合理，同意提交' },
      { level: 2, approverName: '李审批', role: '财务审批', status: 'pending' },
      { level: 3, approverName: '刘科长', role: '院长审批', status: 'pending' },
    ],
  },
  {
    id: 'wa4',
    type: 'purchase_plan',
    title: '检验科2026年度设备更新采购计划',
    applicant: '黄主任',
    department: '检验科',
    status: 'approved',
    createdAt: '2026-07-15T08:00:00Z',
    updatedAt: '2026-07-18T16:00:00Z',
    description: '检验科年度设备更新计划，包括全自动生化分析仪配件更换和实验室信息管理系统升级。总预算150000元。',
    relatedInfo: '计划编号：JH2026-ND-005；预算金额：¥150,000.00；预算科目：设备更新',
    approvalSteps: [
      { level: 1, approverName: '黄主任', role: '部门主管', status: 'approved', approvedAt: '2026-07-16T10:00:00Z', comment: '设备确实需要更新，检验质量必须保障' },
      { level: 2, approverName: '李审批', role: '财务审批', status: 'approved', approvedAt: '2026-07-17T14:00:00Z', comment: '预算充足，符合年度计划' },
      { level: 3, approverName: '刘科长', role: '院长审批', status: 'approved', approvedAt: '2026-07-18T16:00:00Z', comment: '同意，按计划执行' },
    ],
  },
  {
    id: 'wa5',
    type: 'listing',
    title: '75%医用酒精消毒湿巾上架申请',
    applicant: '孙管理员',
    department: '后勤部',
    status: 'rejected',
    createdAt: '2026-07-20T11:00:00Z',
    updatedAt: '2026-07-21T09:00:00Z',
    description: '申请新增75%医用酒精消毒湿巾，独立包装，适用于快速手部消毒和物体表面擦拭。',
    relatedInfo: '供应商：广西清洁用品有限公司；预计月用量：500包',
    approvalSteps: [
      { level: 1, approverName: '赵主任', role: '科室主管', status: 'approved', approvedAt: '2026-07-20T15:00:00Z', comment: '同意，方便科室使用' },
      { level: 2, approverName: '王管理员', role: '平台管理员', status: 'rejected', approvedAt: '2026-07-21T09:00:00Z', comment: '同类产品已存在，无需重复上架。建议使用现有75%酒精喷雾产品。' },
      { level: 3, approverName: '刘科长', role: '设备科审批', status: 'pending' },
    ],
  },
];